import { Loader } from 'actions/actionTypes';

export const changeLoadingRequest = () => ({ type: Loader.CHANGE_LOADING_REQUEST });
export const changeLoadingResponse = () => ({ type: Loader.CHANGE_LOADING_RESPONSE });
export const changePageLoad = (isPageLoad) => ({ type: Loader.CHANGE_PAGE_LOAD, payload: isPageLoad });
